import axios from "@/store/axiosInstance";

const state = {
    catering: [],
    categories: [],
    selection: {},
}

const getters = {
    getCateringItems: state => state.catering,
    getCateringItemsByCategory: state => category => {
        return state.catering.filter(el => {
            return el.categoryList.filter(elem => elem.name === category).length > 0;
        });
    },
    getCateringItemsByCategorySlug: state => slug => {
        return state.catering.filter(el => {
            return el.categoryList.filter(elem => elem.slug === slug).length > 0;
        });
    },
    getCategoryById: state => id => {
        return state.categories.find(el => el.id === id);
    },
    getSubCategoriesByCategoryName: state => name => {
        let parent = state.categories.find(el => el.name === name);
        return state.categories.filter(el => el.parent === parent.id);
    },
    getCategoryDescription: state => categorySlug => {
        let res = state.categories.find((el) => el.slug === categorySlug);
        return res !== undefined ? res.description : "";
    },
    getSelection: state => state.selection,
}

const actions = {
    fetchCateringItems({ commit }) {
        axios.get("/son_catering/v1/items")
            .then(
                res => {
                    commit("setCateringItems", res.data);
                }
            )
            .catch(err => console.error(err));
    },
    fetchCategories({ commit }) {
        axios.get("/wp/v2/catering_category?_fields[]=name&_fields[]=parent&_fields[]=id&_fields[]=description&_fields[]=slug&_fields[]=image&per_page=100")
            .then(res => commit("setCategories", res.data))
            .catch(err => console.error(err));
    }
}

const mutations = {
    setCateringItems: (state, items) => state.catering = items,
    setCategories: (state, cat) => state.categories = cat,
    setSelection: (state, selection) => {
        state.selection = selection;
        let keys = Object.keys(state.selection);
        keys.forEach(el => {
            if (!state.selection[el] || state.selection[el] === "") {
                delete state.selection[el];
            }
        })
    },
    remove: (state, key) => {
        let obj = Object.assign({}, state.selection);
        delete obj[key];
        state.selection = obj;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}